import {
  COMMUNICATION_LOADING,
  COMMUNICATION_ERROR,
  GET_EMAIL_TEMPLATES_SUCCESS,
  CREATE_EMAIL_TEMPLATE_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_SUCCESS,
  DELETE_EMAIL_TEMPLATE_SUCCESS,
  GET_WHATSAPP_TEMPLATES_SUCCESS,
  CREATE_WHATSAPP_TEMPLATE_SUCCESS,
  GET_CAMPAIGNS_SUCCESS,
  CREATE_CAMPAIGN_SUCCESS,
  EXECUTE_CAMPAIGN_SUCCESS,
  SEND_INVOICE_SUCCESS,
  SEND_BIRTHDAY_WISHES_SUCCESS,
  SEND_OFFER_NOTIFICATION_SUCCESS,
  UPDATE_EMAIL_CONFIG_SUCCESS,
  UPDATE_WHATSAPP_CONFIG_SUCCESS,
  GET_COMMUNICATION_STATS_SUCCESS,
  GET_WHATSAPP_STATUS_REQUEST,
  GET_WHATSAPP_STATUS_SUCCESS,
  GET_WHATSAPP_STATUS_FAILURE
} from '../actions/communicationActions';

const initialState = {
  loading: false,
  error: null,
  emailTemplates: [],
  whatsappTemplates: [],
  campaigns: [],
  communicationStats: [],
  emailConfig: null,
  whatsappConfig: null,
  whatsappStatus: {
    connected: false,
    mode: null,
    status: 'unknown',
    message: '',
    loading: false
  }
};

const communicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMMUNICATION_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case COMMUNICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Email Templates
    case GET_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplates: action.payload,
        error: null
      };

    case CREATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplates: [...state.emailTemplates, action.payload],
        error: null
      };

    case UPDATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplates: state.emailTemplates.map(template =>
          template.id === action.payload.id ? action.payload : template
        ),
        error: null
      };

    case DELETE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplates: state.emailTemplates.filter(template => template.id !== action.payload),
        error: null
      };

    // WhatsApp Templates
    case GET_WHATSAPP_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        whatsappTemplates: action.payload,
        error: null
      };

    case CREATE_WHATSAPP_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        whatsappTemplates: [...state.whatsappTemplates, action.payload],
        error: null
      };

    // Campaigns
    case GET_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        campaigns: action.payload,
        error: null
      };

    case CREATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        campaigns: [...state.campaigns, action.payload],
        error: null
      };

    case EXECUTE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        campaigns: state.campaigns.map(campaign =>
          campaign.id === action.payload.id ? action.payload : campaign
        ),
        error: null
      };

    // Communication
    case SEND_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    case SEND_BIRTHDAY_WISHES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    case SEND_OFFER_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    // Configuration
    case UPDATE_EMAIL_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        emailConfig: action.payload,
        error: null
      };

    case UPDATE_WHATSAPP_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        whatsappConfig: action.payload,
        error: null
      };

    // Analytics
    case GET_COMMUNICATION_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        communicationStats: action.payload,
        error: null
      };

    // WhatsApp Status
    case GET_WHATSAPP_STATUS_REQUEST:
      return {
        ...state,
        whatsappStatus: {
          ...state.whatsappStatus,
          loading: true
        }
      };

    case GET_WHATSAPP_STATUS_SUCCESS:
      return {
        ...state,
        whatsappStatus: {
          ...action.payload,
          loading: false
        }
      };

    case GET_WHATSAPP_STATUS_FAILURE:
      return {
        ...state,
        whatsappStatus: {
          ...state.whatsappStatus,
          loading: false,
          connected: false,
          status: 'error',
          message: action.payload
        }
      };

    default:
      return state;
  }
};

export default communicationReducer;